import { createBrowserRouter } from "react-router-dom";
import DashboardLayout from "../../Layout/DashboardLayout";
import Main from "../../Layout/Main";
import Blog from "../../Pages/Blog/Blog";
import AllUsers from "../../Pages/Dashboard/AllUsers/AllUsers";
import Seller from "../../Pages/Dashboard/Seller/Seller";
import Buyer from "../../Pages/Dashboard/Buyer/Buyer";
import Dashboard from "../../Pages/Dashboard/Dashboard/Dashboard";
import AddProduct from "../../Pages/Dashboard/Seller/AddProduct";
import MyProduct from "../../Pages/Dashboard/Seller/MyProduct";
import ErrorPage from "../../Pages/ErrorPage/ErrorPage";
import Bajaj from "../../Pages/Home/BikeCategories/Bajaj/Bajaj";
import BajajBike from "../../Pages/Home/BikeCategories/Bajaj/BajajBike";
import BikeDetails from "../../Pages/Home/BikeCategories/BikeDetails";
import Hero from "../../Pages/Home/BikeCategories/Hero/Hero";
import HeroBike from "../../Pages/Home/BikeCategories/Hero/HeroBike";
import Runner from "../../Pages/Home/BikeCategories/Runner/Runner";
import RunnerBike from "../../Pages/Home/BikeCategories/Runner/RunnerBike";
import Suzuki from "../../Pages/Home/BikeCategories/Suzuki/Suzuki";
import SuzukiBike from "../../Pages/Home/BikeCategories/Suzuki/SuzukiBike";
import Home from "../../Pages/Home/Home/Home";
import Login from "../../Pages/Login/Login";
import SignUp from "../../Pages/SignUp/SignUp";
import PrivateRoute from "../PrivateRoute/PrivateRoute";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Main></Main>,
    children: [
      {
        path: "/",
        element: <Home></Home>,
      },
      {
        path: "/login",
        element: <Login></Login>,
      },
      {
        path: "/signup",
        element: <SignUp></SignUp>,
      },
      {
        path: "/blog",
        element: <Blog></Blog>,
      },

      // suzuki bike
      {
        path: "/bikes/suzuki",
        element: <Suzuki></Suzuki>,
      },

      {
        path: "/suzukibike",
        element: <SuzukiBike></SuzukiBike>,
      },

      // hero bike
      {
        path: "/bikes/hero",
        element: <Hero></Hero>,
      },
      {
        path: "/herobike",
        element: <HeroBike></HeroBike>,
      },

      // runner bike
      {
        path: "/bikes/runner",
        element: <Runner></Runner>,
      },
      {
        path: "/runnerbike",
        element: <RunnerBike></RunnerBike>,
      },

      // runner bike
      {
        path: "/bikes/bajaj",
        element: <Bajaj></Bajaj>,
      },
      {
        path: "/bajajbike",
        element: <BajajBike></BajajBike>,
      },

      // bike details route
      {
        path: "/bike/:id",
        element: <BikeDetails></BikeDetails>,
      },
    ],
  },
  {
    path: "*",
    element: <ErrorPage></ErrorPage>,
  },
  {
    path: "/dashboard",
    element: (<PrivateRoute><DashboardLayout></DashboardLayout></PrivateRoute>),
    children: [
      {
        path: "/dashboard",
        element: <Dashboard></Dashboard>,
      },
      {
        path: "/dashboard/allusers",
        element: <AllUsers></AllUsers>,
      },
      {
        path: "/dashboard/seller",
        element: <Seller></Seller>,
        children: [
          {
            path: "/dashboard/seller/addproduct",
            element: <AddProduct></AddProduct>,
          },
    
          {
            path: "/dashboard/seller/myproduct",
            element: <MyProduct></MyProduct>,
          },
        ],
      },
      {
        path: "/dashboard/buyer",
        element: <Buyer></Buyer>,
      },
    ],
  }
]);

export default router;
